import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./layout.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./layout.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/layout.vue?vue&type=script&lang=js&
// module id = 195
// module chunks = 2